import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Select,
  Modal,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";

const monthOptions = [
  { label: "January", value: "1" },
  { label: "February", value: "2" },
  { label: "March", value: "3" },
  { label: "April", value: "4" },
  { label: "May", value: "5" },
  { label: "June", value: "6" },
  { label: "July", value: "7" },
  { label: "August", value: "8" },
  { label: "September", value: "9" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

const AddEditBirthdayPackage = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );

  const [optionsElements, setOptionsElements] = useState([]);
  const [optionsClasses, setOptionsClasses] = useState([]);

  const [item, setItem] = useState({
    name: "",
    month: "",
    description: "",
    price: "",
    validity: "",
    validityType: "",
    freeBookingsCount: "",
    isActive: true,
    elements: [],
    classes: [],
  });

  const handleChangeName = (newValue) => {
    setItem({ ...item, name: newValue });
    setNameError("");
  };
  const [nameError, setNameError] = useState("");

  const handleChangeMonth = (newValue) => {
    setItem({ ...item, month: newValue });
    setMonthError("");
  };
  const [monthError, setMonthError] = useState("");

  const handleChangeDescription = (newValue) => {
    setItem({ ...item, description: newValue });
  };

  const handleChangePrice = (newValue) => {
    setItem({ ...item, price: newValue });
    setPriceError("");
  };
  const [priceError, setPriceError] = useState("");

  const handleChangeValidity = (newValue) => {
    setItem({ ...item, validity: newValue });
  };

  const handleChangeValidityType = (newValue) => {
    setItem({ ...item, validityType: newValue });
  };

  const handleChangeFreeBookingsCount = (newValue) => {
    setItem({ ...item, freeBookingsCount: newValue });
    setFreeBookingsCountError("");
  };
  const [freeBookingsCountError, setFreeBookingsCountError] = useState("");

  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };

  const [elementsError, setElementsError] = useState("");
  const [classesError, setClassesError] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  // Fetch classes when selected elements change
  useEffect(() => {
    if (item.elements.length) {
      axios
        .get(
          `/classes-list-by-element?element_ids=${item.elements.join(",")}`
        )
        .then((result) => {
          setOptionsClasses(
            result.data.data.map((item) => {
              return {
                label: item.name,
                value: String(item.id),
              };
            })
          );
        })
        .catch((err) => console.log(err));
    } else {
      setOptionsClasses([]);
    }
  }, [item.elements.join(",")]);

  async function fetchData() {
    let responseElements = [];
    let responseClasses = [];

    try {
      responseElements = await axios.get(`/elements`);
      setOptionsElements(
        responseElements.data.data.data.map((item) => {
          return {
            label: item.title,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    try {
      responseClasses = await axios.get(`/classes-list`);
      setOptionsClasses(
        responseClasses.data.data.map((item) => {
          return {
            label: item.name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    if (props.type === "edit") {
      try {
        const responseItem = await axios.get(`/birthday-packages/${id}`);
        const data = responseItem.data.data;
        setItem({
          name: data.name || "",
          month: data.month ? String(data.month) : "",
          description: data.description || "",
          price:
            data.price !== null && data.price !== undefined
              ? String(data.price)
              : "",
          validity:
            data.validity !== null && data.validity !== undefined
              ? String(data.validity)
              : "",
          validityType: data.validity_type || "",
          freeBookingsCount:
            data.free_bookings_count !== null &&
            data.free_bookings_count !== undefined
              ? String(data.free_bookings_count)
              : "",
          isActive: data.is_active ?? true,
          elements: data.elements
            ? data.elements.map((el) => String(el.id))
            : [],
          classes: data.classes
            ? data.classes.map((cl) => String(cl.id))
            : [],
        });
      } catch (error) {
        console.log(error);
      }
    }
    setIsSaving(false);
  }

  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/birthday-packages/${id}`)
      .then((result) => {
        navigate("/admin/birthday-packages");
      })
      .catch((err) => console.log(err));
  };

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState("");
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;

  return (
    <Page
      title={props.title}
      backAction={{ onAction: () => navigate("/admin/birthday-packages") }}
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <TextField
            value={item.name}
            onChange={handleChangeName}
            label="Name"
            error={nameError}
          />

          <Select
            label="Month"
            options={monthOptions}
            onChange={handleChangeMonth}
            value={item.month}
            placeholder="Please select"
            error={monthError}
          />

          <TextField
            value={item.description}
            onChange={handleChangeDescription}
            label="Description"
            multiline={4}
          />

          <TextField
            value={item.price}
            onChange={handleChangePrice}
            label="Price"
            type="number"
            error={priceError}
          />

          <FormLayout.Group>
            <TextField
              value={item.validity}
              onChange={handleChangeValidity}
              label="Validity"
              type="number"
            />
            <Select
              label="Validity Type"
              options={[
                { label: "Hours", value: "hours" },
                { label: "Days", value: "days" },
                { label: "Months", value: "months" },
              ]}
              onChange={handleChangeValidityType}
              value={item.validityType}
              placeholder="Please select"
            />
          </FormLayout.Group>

          <TextField
            value={item.freeBookingsCount}
            onChange={handleChangeFreeBookingsCount}
            label="Free Bookings Count"
            type="number"
            error={freeBookingsCountError}
          />

          <Text>Elements</Text>
          <MultiSelect
            value={item.elements}
            options={optionsElements}
            onChange={(e) => {
              setItem({ ...item, elements: e.value });
              setElementsError("");
            }}
            filter={true}
            placeholder="Please select"
            style={{ width: "100%" }}
            selectAllLabel="Select All"
            display="chip"
          />
          <InlineError message={elementsError} />

          <Text>Classes</Text>
          <MultiSelect
            value={item.classes}
            options={optionsClasses}
            onChange={(e) => {
              setItem({ ...item, classes: e.value });
              setClassesError("");
            }}
            filter={true}
            placeholder="Please select"
            style={{ width: "100%" }}
            selectAllLabel="Select All"
            display="chip"
          />
          <InlineError message={classesError} />

          <Checkbox
            label="Is Active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving,
        }}
        secondaryActions={
          props.type === "edit"
            ? [
                {
                  content: "Delete",
                  destructive: true,
                  onClick: () => setActiveDelete(true),
                },
              ]
            : []
        }
      />
      {props.type === "edit" && (
        <Modal
          open={activeDelete}
          onClose={handleChangeModalDelete}
          title="Delete Birthday Package"
          primaryAction={{
            content: "Yes",
            onAction: handleYesDelete,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "No",
              loading: isSaving,
              onAction: handleChangeModalDelete,
            },
          ]}
        >
          <Modal.Section>
            <Text>
              <p>Are you sure you want to delete this birthday package?</p>
            </Text>
          </Modal.Section>
        </Modal>
      )}
      {toastMarkup}
    </Page>
  );

  function handleSave() {
    if (
      item.name === "" ||
      item.month === "" ||
      item.price === "" ||
      item.freeBookingsCount === "" ||
      !item.elements.length ||
      !item.classes.length
    ) {
      item.name === "" && setNameError("Please enter a name");
      item.month === "" && setMonthError("Please select a month");
      item.price === "" && setPriceError("Please enter a price");
      item.freeBookingsCount === "" &&
        setFreeBookingsCountError("Please enter free bookings count");
      !item.elements.length &&
        setElementsError("Please select at least one element");
      !item.classes.length &&
        setClassesError("Please select at least one class");
    } else {
      setIsSaving(true);
      const bodyObj = {
        name: item.name,
        month: Number(item.month),
        description: item.description,
        price: Number(item.price),
        validity: item.validity ? Number(item.validity) : null,
        validity_type: item.validityType || null,
        free_bookings_count: Number(item.freeBookingsCount),
        is_active: item.isActive,
        element_ids: item.elements.map(Number),
        class_ids: item.classes.map(Number),
      };

      if (props.type === "edit") {
        axios
          .put(`/birthday-packages/${id}`, bodyObj)
          .then((result) => {
            setToastContent("Changes have been saved successfully");
            toggleActive();
            setIsSaving(false);
          })
          .catch((error) => {
            setIsSaving(false);
            console.log(error);
          });
      } else {
        axios
          .post(`/birthday-packages`, bodyObj)
          .then((result) => {
            navigate("/admin/birthday-packages");
          })
          .catch((error) => {
            setIsSaving(false);
            console.log(error);
          });
      }
    }
  }
};

export default AddEditBirthdayPackage;
